import { ExerciseData } from './Exercise'
import { Content } from './Content'
import { ResultData } from './Result'
import { Translatable } from '../common/types/translatable'
import { Therapist } from './Therapist'
import { Feedback } from './Feedback'

export enum FeedType {
  CONTENT = 'CONTENT',
  EXERCISE = 'EXERCISE',
  FEEDBACK = 'FEEDBACK',
  RESULT = 'RESULT',
  THERAPIST = 'THERAPIST',
}

export type Feed =
  | ContentFeed
  | ExerciseFeed
  | ResultFeed
  | TherapistFeed
  | FeedbackFeed

export interface ContentFeed {
  id: string
  type: FeedType.CONTENT
  content: Content
}

export interface ExerciseFeed {
  id: string
  type: FeedType.EXERCISE
  content: ExerciseData
}

export interface ResultFeed {
  id: string
  title: Translatable
  type: FeedType.RESULT
  content: ResultData
}

export interface TherapistFeed {
  id: number
  type: FeedType.THERAPIST
  content: Therapist
}

export interface FeedbackFeed {
  id: number
  type: FeedType.FEEDBACK
  content: Feedback
}

// Type guards
export function isContentFeed(post: Feed): post is ContentFeed {
  return post.type === FeedType.CONTENT
}

export function isExerciseFeed(post: Feed): post is ExerciseFeed {
  return post.type === FeedType.EXERCISE
}

export function isResultFeed(post: Feed): post is ResultFeed {
  return post.type === FeedType.RESULT
}
